import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { withTranslation } from 'react-i18next';
import { MultiRadio, Modal as WarningModal } from 'shared/components';
import { mapTypeOptions, mapTimingOptions, applyActNatlTimingNames } from 'shared/helpers';
import { ValidationService } from 'shared/services';
import { isEmpty } from 'lodash';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
};

class EditRoomType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      room: {
        ...props.room,
        roomType: props.room && props.room.roomType ? props.room.roomType.id : null,
      },
      roomTypeOptions: mapTypeOptions(props.roomTypes, props.room.roomType.onlineFlag),
      examOptions: applyActNatlTimingNames(
        mapTimingOptions(
          props.roomTypes,
          props.mappedRoomTiming,
          props.room && props.room.roomType ? props.room.roomType.id : null
        ),
        props.programCode
      ),
      errors: {},
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeTiming = this.onChangeTiming.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    this.setState({
      examOptions: applyActNatlTimingNames(
        mapTimingOptions(
          this.props.roomTypes,
          this.props.mappedRoomTiming,
          e.target.value
        ),
        this.props.programCode
      ),
      room: {
        ...this.state.room,
        [e.target.name]: e.target.value,
        timing: '',
      },
      errors: {},
    });
  }

  onChangeTiming(e) {
    this.setState({
      room: {
        ...this.state.room,
        timing: e.target.value,
      },
      errors: {},
    });
  }

  onSubmit() {
    let errors = ValidationService.validate(
      this.state.room,
      { timing: ['required'] },
      { timing: { required: 'errors.timingCategoryRequired' } }
    );
    if (!isEmpty(errors)) {
      this.setState({
        errors,
      });
      return;
    }
    this.props.onSave(this.state.room, true);
  }

  render() {
    const { examOptions, room } = this.state;
    const { timingWarningModalOpen } = this.props;

    return (
      <React.Fragment>
        <ReactModal
          isOpen={this.props.isOpen}
          style={customStyles}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          contentLabel="Modal">
          <div className="modal-container modal-edit-room-type">
            <div className="text-strong">{room.label}</div>
            <div className="mb-30">
              {room.location.name}
              {room.location.area && room.location.area.length > 0 && `, ${room.location.area}`}
            </div>

            <div className="mb-20">
              <MultiRadio
                radioList={this.state.roomTypeOptions}
                checkedValue={room.roomType}
                onChange={this.onChange}
                title={this.props.t('roomBuilder.roomTypeLabel')}
                required
              />
            </div>

            <div>
              <MultiRadio
                radioList={examOptions}
                checkedValue={room.timing}
                onChange={this.onChangeTiming}
                title={this.props.t('roomBuilder.timingCategoryLabel')}
                errors={this.state.errors.timing}
                required
              />
            </div>

            <div className="buttons-container w-100">
              <button className="btn btn-outline w-25" onClick={this.props.onCancel} key="btn-1">
                {this.props.t('common.labels.cancel')}
              </button>
              <button className="btn btn-action w-25" onClick={this.onSubmit} key="btn-2">
                {this.props.t('common.labels.save')}
              </button>
            </div>
          </div>
        </ReactModal>
        <WarningModal
          closeModal={this.props.closeWarningModal}
          hideIcon
          onConfirm={() => this.props.onSave(this.state.room)}
          open={timingWarningModalOpen}
          modalContent="roomBuilder.timingWarningModal"
        />
      </React.Fragment>
    );
  }
}

EditRoomType.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  room: PropTypes.shape({}),
  programCode: PropTypes.string,
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    roomTypes: state.statics.roomTypes,
  };
}

export default withTranslation()(connect(mapStateToProps)(EditRoomType));
